import styled from 'styled-components';
import { Colors, FontSize } from '../../../assets';
import { Container, ContainerItem, Wrapper } from '../../elements';
import { GiHamburgerMenu } from 'react-icons/gi';
import { VscTriangleLeft, VscTriangleRight } from 'react-icons/vsc';

export const SidebarWrapper = styled(Wrapper)<{ $isCollapsed: boolean }>`
  background: linear-gradient(180deg, ${Colors.primary} 0%, ${Colors.secondary} 100%);
  box-shadow: 4px 0px 16px rgba(0, 0, 0, 0.2);
  width: ${(props) => (props.$isCollapsed ? '60px' : '200px')};
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  z-index: 2;
`;
export const SidebarHeader = styled.div`
  background-color: ${Colors.black};
  display: flex;
  padding: 1rem 0.5rem 1rem 0.5rem;
  height: 68px;
`;
export const Icon = styled(GiHamburgerMenu)`
  font-size: ${FontSize.icon};
  color: ${Colors.white};
`;

export const ArrowContainer = styled(Container)`
  align-items: center;
`;

export const ArrowLeft = styled(VscTriangleLeft)`
  font-size: ${FontSize.smallIcon};
  color: ${Colors.white};
`;

export const ArrowRight = styled(VscTriangleRight)`
  font-size: ${FontSize.smallIcon};
  color: ${Colors.white};
`;
export const SidebarNavigationContainer = styled(Container)`
  flex: 1 1 90%;
  padding: 1rem 0.75rem;
  display: flex;
  justify-content: flex-start;
  transition: all 0.3s ease;

  & a {
    font-size: ${FontSize.normal};
    font-weight: 500;
    letter-spacing: 0.3px;
  }

  & a:hover {
    color: ${Colors.orange};
  }

  & ul {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const FullNavigation = styled(Container)`
  & li a {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    transition: all 0.3s ease;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 0;
      background-color: ${Colors.orange};
      border-radius: 0 2px 2px 0;
      transition: height 0.3s ease;
    }

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);

      &::before {
        height: 60%;
      }
    }
  }

  & span {
    font-size: ${FontSize.normal};
    font-weight: 500;
  }
`;

export const SidebarFooter = styled(ContainerItem)`
  flex: 1 1 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.5rem;

  & span {
    font-size: ${FontSize.small};
    color: ${Colors.lightText};
    font-weight: 400;
  }
`;
